export function isReadableStream(value) {
    return (!!value &&
        Object.prototype.toString.call(value) === '[object ReadableStream]');
}
//# sourceMappingURL=is_readable_stream.js.map